var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('loading',{attrs:{"active":_vm.loading,"loader":'dots',"color":'#58f0ac',"width":128,"background-color":'#000',"opacity":0.75,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }